module.exports = __webpack_public_path__ + "static/img/qd_card_bg.8af049f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solve/qd_card_bg.png
// module id = 6TDI
// module chunks = 1